// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
    padding: 64px 0;
    display: flex;
    flex-direction: column;
}

.login form {
    display: flex;
    justify-content: space-evenly;
    width: 530px;
    margin: 0 auto;
}

.loginController {
    display: flex;
    flex-direction: column;
    width: 320px;
    height: 130px;
    justify-content: space-evenly;
}

.loginController span {
    font-weight: bold;
}

.loginController > div {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.loginController > div:nth-child(1) {
    font-size: 14px;
}

.loginController > div:nth-child(2), .loginController > div:nth-child(3) {
    justify-content: space-between;
}

.loginController > div:nth-child(2) input, .loginController > div:nth-child(3) input {
    width: 230px;
    border: 1px solid #323232;
    height: 34px;
    box-sizing: border-box;
    padding: 0 10px;
    font-size: 13px;
}

#loginBtn {
    height: 78px;
    margin-top: 40px;
    padding: 0 32px;
    font-size: 16px;
}

.login-extra {
    display: flex;
    flex-direction: column;
    height: 100px;
    align-items: center;
    justify-content: space-evenly;
}

.login-extra p {
    font-size: 15px;
    width: 275px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
}

.loginExtraController {
    width: 275px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.loginExtraController button {
    padding: 6px 12px;
    margin-right: 25px;
    font-size: 13px;
}

@media screen and (max-width: 900px) {
    .login form {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .loginController {
        margin: 0 auto;
        height: 200px;
        align-items: flex-start;
        width: 100%;
        max-width: 320px;
    }

    .loginController span {
        font-size: 15px;
    }

    .loginController > div:nth-child(1) {
        font-size: 15px;
    }

    .loginController > div:nth-child(2), .loginController > div:nth-child(3) {
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
    }

    .loginController > div:nth-child(2) input, .loginController > div:nth-child(3) input{
        width: 100%;
        font-size: 15px;
    }

    #loginBtn {
        height: 50px;
        max-width: 320px;
        width: 100%;
        margin: 0;
        font-size: 18px;
    }

    .login-extra {
        height: 150px;
    }

    .login-extra p {
        font-size: 18px;
        max-width: 320px;
        width: 100%;
        display: block;
    }

    .loginExtraController {
        max-width: 320px;
        width: 100%;
        justify-content: space-around;
    }

    .loginExtraController button {
        padding: 8px 30px;
        margin: 0;
        font-size: 15px;
    }
}

@media screen and (max-width: 320px) {

}`, "",{"version":3,"sources":["webpack://./src/styles/LogIn.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,cAAc;QACd,aAAa;QACb,uBAAuB;QACvB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,WAAW;QACX,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;QACjB,SAAS;QACT,eAAe;IACnB;AACJ;;AAEA;;AAEA","sourcesContent":[".login {\n    padding: 64px 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.login form {\n    display: flex;\n    justify-content: space-evenly;\n    width: 530px;\n    margin: 0 auto;\n}\n\n.loginController {\n    display: flex;\n    flex-direction: column;\n    width: 320px;\n    height: 130px;\n    justify-content: space-evenly;\n}\n\n.loginController span {\n    font-weight: bold;\n}\n\n.loginController > div {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n}\n\n.loginController > div:nth-child(1) {\n    font-size: 14px;\n}\n\n.loginController > div:nth-child(2), .loginController > div:nth-child(3) {\n    justify-content: space-between;\n}\n\n.loginController > div:nth-child(2) input, .loginController > div:nth-child(3) input {\n    width: 230px;\n    border: 1px solid #323232;\n    height: 34px;\n    box-sizing: border-box;\n    padding: 0 10px;\n    font-size: 13px;\n}\n\n#loginBtn {\n    height: 78px;\n    margin-top: 40px;\n    padding: 0 32px;\n    font-size: 16px;\n}\n\n.login-extra {\n    display: flex;\n    flex-direction: column;\n    height: 100px;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n.login-extra p {\n    font-size: 15px;\n    width: 275px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: flex-start;\n}\n\n.loginExtraController {\n    width: 275px;\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.loginExtraController button {\n    padding: 6px 12px;\n    margin-right: 25px;\n    font-size: 13px;\n}\n\n@media screen and (max-width: 900px) {\n    .login form {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        width: 100%;\n    }\n\n    .loginController {\n        margin: 0 auto;\n        height: 200px;\n        align-items: flex-start;\n        width: 100%;\n        max-width: 320px;\n    }\n\n    .loginController span {\n        font-size: 15px;\n    }\n\n    .loginController > div:nth-child(1) {\n        font-size: 15px;\n    }\n\n    .loginController > div:nth-child(2), .loginController > div:nth-child(3) {\n        width: 100%;\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .loginController > div:nth-child(2) input, .loginController > div:nth-child(3) input{\n        width: 100%;\n        font-size: 15px;\n    }\n\n    #loginBtn {\n        height: 50px;\n        max-width: 320px;\n        width: 100%;\n        margin: 0;\n        font-size: 18px;\n    }\n\n    .login-extra {\n        height: 150px;\n    }\n\n    .login-extra p {\n        font-size: 18px;\n        max-width: 320px;\n        width: 100%;\n        display: block;\n    }\n\n    .loginExtraController {\n        max-width: 320px;\n        width: 100%;\n        justify-content: space-around;\n    }\n\n    .loginExtraController button {\n        padding: 8px 30px;\n        margin: 0;\n        font-size: 15px;\n    }\n}\n\n@media screen and (max-width: 320px) {\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
